<ion-grid>
	<ion-row>
		<ion-col>
			<ion-grid class="max-w-1336" *ngIf="openDoorList$ | async as openDoorList">
				<ng-container *ngIf="openDoorList.isSkeleton">
					<ion-grid class="side-menu-wrapper text-center">
						<ion-spinner class="ion-spinner"></ion-spinner>
					</ion-grid>
				</ng-container>
				<ng-container *ngIf="!openDoorList.isSkeleton">
					<ion-row>
						<ion-col col="12">
							<dx-data-grid id="gridContainer" [dataSource]="openDoorList.data"
								[allowColumnResizing]="true" [columnAutoWidth]="true" [showBorders]="true">

								<dxo-export [enabled]="true"></dxo-export>

								<dxo-search-panel [visible]="true" [width]="240"
									placeholder="Search..."></dxo-search-panel>
								<dxo-header-filter>
									[visible]="showHeaderFilter"
								</dxo-header-filter>
								<dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
								<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

								<dxi-column caption="Actions" dataField="id" [allowFiltering]="false"
									[allowSorting]="false" cellTemplate="cellTemplate" [width]="150">
								</dxi-column>

								<dxi-column dataField="firstName" caption="First Name"></dxi-column>
								<dxi-column dataField="lastName" caption="Last Name"></dxi-column>
								<dxi-column dataField="email" caption="Email"></dxi-column>
								<dxi-column dataField="calendlyUrl" caption="calendly Url"></dxi-column>

								<dxi-column caption="Available For Meet" dataField="availableForMeet"
									cellTemplate="cellTemplateOnboarding">
								</dxi-column>

								<div *dxTemplate="let d of 'cellTemplateOnboarding'">

									<div class="dx-field">
										<div class="dx-field-value">
											<dx-check-box [value]="!!d.data.availableForMeet"
												(onValueChanged)="updateStudentMeetButton(d.data, $event)"></dx-check-box>
										</div>
									</div>

									<!-- 									
									<p appConfirmBox (learnDelete)="updateStudentOnboarding(d.data.email)"
										title="Update onboarding" buttonText="Yes, Confirm"
										subTitle="Are you sure you want to complete Onboarding ?"
										class="Body_S text-right cursor">
										Update Onboarding
									</p> -->
								</div>

								<dxi-column dataField="story" caption="Story"></dxi-column>

								<div *dxTemplate="let d of 'cellTemplate';">
									<a appConfirmBox (learnDelete)="updateCompanyStatus(d.data,'approved')"
										title="Profile Open Door status"
										subTitle="Are you sure you want to update Profile Open Door status?"
										buttonText="Yes, Update" class="cursor"
										*ngIf="d.data.approveStatus !== 'approved'"><b>Approve</b></a>
									<ng-container *ngIf="d.data.approveStatus === 'pending'">
										/
									</ng-container>
									<a appConfirmBox (learnDelete)="updateCompanyStatus(d.data,'rejected')"
										title="Update Profile Open Door status"
										subTitle="Are you sure you want to update Profile Open Door status?"
										buttonText="Yes, Update" class="cursor"
										*ngIf="d.data.approveStatus !== 'rejected'"><b>Reject</b></a>
								</div>

								<dxo-toolbar>
									<dxi-item location="before">
										<div *dxTemplate class="informer">
											<p class="Heading_M">Open Door Profiles Status</p>
										</div>


									</dxi-item>

									<dxi-item>
										<ion-buttons class="center">
											Open Door Profiles Status :
											<ion-select placeholder="Select Status" interface="popover"
												(ionChange)="handleChange($event)" value="pending">
												<ion-select-option value="pending" selected>Pending</ion-select-option>
												<ion-select-option value="approved">Approved</ion-select-option>
												<ion-select-option value="rejected">Rejected</ion-select-option>
											</ion-select>
										</ion-buttons>
									</dxi-item>

									<dxi-item name="exportButton"></dxi-item>

									<dxi-item name="columnChooserButton"></dxi-item>

									<dxi-item name="searchPanel"></dxi-item>

								</dxo-toolbar>
							</dx-data-grid>
						</ion-col>
					</ion-row>
				</ng-container>


			</ion-grid>
		</ion-col>
	</ion-row>
</ion-grid>